// extracted by mini-css-extract-plugin
export default {"wrapper":"Filters_wrapper__Qe3EC"};